import moment from "moment";
import CommonConfirmationProductDetailSection from "../../components/common/CommonConfirmationProductDetailSection.jsx";

function PackageConfirmationTourDetailSection({ booking }) {
  if (!booking) return <></>;

  function getTravelersString(totals) {
    const parts = [];

    if (totals.totalAdults > 0) {
      parts.push(
        `${totals.totalAdults} adult${totals.totalAdults > 1 ? "s" : ""}`,
      );
    }
    if (totals.totalSeniors > 0) {
      parts.push(
        `${totals.totalSeniors} senior${totals.totalSeniors > 1 ? "s" : ""}`,
      );
    }
    if (totals.totalStudents > 0) {
      parts.push(
        `${totals.totalStudents} student${totals.totalStudents > 1 ? "s" : ""}`,
      );
    }
    if (totals.totalChildrens > 0) {
      parts.push(
        `${totals.totalChildrens} child${totals.totalChildrens > 1 ? "ren" : ""}`,
      );
    }
    if (totals.totalInfants > 0) {
      parts.push(
        `${totals.totalInfants} infant${totals.totalInfants > 1 ? "s" : ""}`,
      );
    }
    if (totals.totalMilitaries > 0) {
      parts.push(
        `${totals.totalMilitaries} military${totals.totalMilitaries > 1 ? "" : ""}`,
      );
    }

    return parts.length > 0 ? parts.join(", ") : "0 travelers";
  }

  const detailData = [
    {
      icon: "/tourIconDate.svg",
      value: `${moment(booking?.startDate).format("dddd, DD MMM")} ${
        booking?.startDate
          ? `, ${moment(booking?.startDate, "HH:mm").format("h:mm A")}`
          : ""
      }`,
    },
    {
      icon: "/IconTime.svg",
      value: booking?.option?.accessTime,
    },
    {
      icon: "/tourIconPerson.svg",
      value: getTravelersString(booking?.requestBody),
    },
  ];

  const moreDetailData = [
    {
      icon: "/tourIconPerson.svg",
      value: getTravelersString(booking?.requestBody),
    },
  ];

  return (
    <CommonConfirmationProductDetailSection
      data={[
        {
          type: booking?.nobiPackageInfo?.title,
          title: booking?.nobiPackageInfo?.title,
          address:
            booking?.nobiPackageInfo?.country +
            ", " +
            booking?.nobiPackageInfo?.city,
          mainDetailWidth: "lg:w-[30%]",
          mainDetails: [
            {
              label: "Duration",
              value: booking?.option?.accessTime,
            },
          ],
          detailWithIcon: detailData,
          moreDetailWithIcon: moreDetailData,
          cancellationPolicy: {
            title: "Order cancellation policy",
            description: booking?.option?.cancelationPolicy.description,
          },
        },
      ]}
    />
  );
}

export default PackageConfirmationTourDetailSection;
